"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "solbiate-olona": {
    "eeaa75a9": [{
      "hkey": "96ed2578",
      "slug": "solbiate-olona",
      "name": "Solbiate Olona",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-brugherezza": [{
      "hkey": "96ed2578",
      "slug": "solbiate-olona",
      "name": "Solbiate Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c6325bb3": [{
      "hkey": "96ed2578",
      "slug": "solbiate-olona",
      "name": "Solbiate Olona",
      "primary": true,
      "skipSearch": false
    }],
    "la-conigliera": [{
      "hkey": "96ed2578",
      "slug": "solbiate-olona",
      "name": "Solbiate Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3893ff51": [{
      "hkey": "96ed2578",
      "slug": "solbiate-olona",
      "name": "Solbiate Olona",
      "primary": true,
      "skipSearch": false
    }],
    "solbiello": [{
      "hkey": "96ed2578",
      "slug": "solbiate-olona",
      "name": "Solbiate Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c11b7b7a": [{
      "hkey": "96ed2578",
      "slug": "solbiate-olona",
      "name": "Solbiate Olona",
      "primary": true,
      "skipSearch": false
    }],
    "zecchi": [{
      "hkey": "96ed2578",
      "slug": "solbiate-olona",
      "name": "Solbiate Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;